import { t as autobizTranslate } from "autobiz-translate";
import { getCurrentLanguage } from "../language-context";
import humanizeDuration from "humanize-duration";
import { useLanguage } from "../AutobizTranslateProvider";

export function t(code, variables = null) {
  if (!code || typeof code !== "string") return code;
  const message = autobizTranslate(code, variables);
  if (message) return message;
  return code;
}
export function durationTranslate(
  language,
  duration,
  units = ["y", "mo"],
  round = true,
  separator = ",",
) {
  let result = humanizeDuration(duration, {
    language: language,
    units,
    round,
    fallbacks: ["en"],
  });
  if (separator !== ",") {
    result = result.replace(",", " " + t(separator));
  }
  return result;
}
